import { Component, Input, OnInit } from '@angular/core';
import { Menu } from '../services/site.model';
import { TranslateService } from '@ngx-translate/core';
import { SiteService } from '../services/site.service';

@Component({
    selector: 'site',
    templateUrl: './site.component.html'
})
export class SiteComponent implements OnInit {
    menus: Menu[];

    constructor(
        private translate: TranslateService,
        private siteService: SiteService
    ) {
    }

    ngOnInit(): void {
        this.setNavMenu();
    }

    setNavMenu(): void {
        this.menus = this.siteService.navigateMenu;
    }
}
